import axios from "axios";
import { Attempt, GameDuration, Level, MoveWithProbability, PlayerColor, TimeControl } from "./models";

interface PostAttemptResponse {
    newRating: number;
    success: boolean;
    ratingGain: number;
}

export const postAttempt = async (
    attempt: Attempt,
    engineLevel: number,
    positionRating: number,
    playerColor: PlayerColor,
    positionId?: number,
    startRating?: number,
    timeControls?: TimeControl[],
    rejectionThreshold?: number,
    gameDuration?: GameDuration,
    isRated?: boolean,
    selectedEngineLevel?: string
): Promise<PostAttemptResponse> => {
    const response = await axios.post<unknown, { data: PostAttemptResponse }>(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_attempt2`,
        {
            attempt,
            engineLevel,
            positionId,
            positionRating,
            playerColor,
            startRating,
            timeControls,
            rejectionThreshold,
            gameDuration,
            isRated,
            selectedEngineLevel,
        },
        {
            withCredentials: true,
        }
    );

    return response.data;
};

export const postExclusions = async (
    positionId: number,
    movesWithProbabilities: MoveWithProbability[],
    fen: string
) => {
    await axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_exclusions`,
        {
            positionId,
            movesWithProbabilities,
            fen,
        },
        {
            withCredentials: true,
        }
    );
};

export const getExclusions = async (positionId: number) => {
    const response = await axios.get<string[]>(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_exclusions/${positionId}`,
        {
            withCredentials: true,
        }
    );

    return response.data;
};

export const deleteExclusion = async (positionId: number, move: string, fen: string) => {
    await axios.delete(`${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_exclusions`, {
        data: {
            positionId,
            move,
            fen,
        },
        withCredentials: true,
    });
};
